import { makeStyles } from '@mui/styles';

const useStyles = makeStyles((theme) => ({
    open: {
        cursor: 'pointer',
        fontSize: '0.9em',
    },
    infoGrid: {
        marginBottom: 5,
    },
    value: {
        fontSize: '0.9rem',
    },
}));

export default useStyles;
